import { MembershipTypes } from '@/enums/member'
import { serializeParameters } from '@/utils/general'
import { getSignupUrl } from '@/utils/signup'

const forwardToRegularSignup = (store, specialDesign) => {
  let prefix = ''

  if (store.state.app.locale && store.state.app.country) {
    prefix = `/${store.state.app.locale}-${store.state.app.country}`
  }

  if (specialDesign.membershipTypeReference === MembershipTypes.women) {
    return `${prefix}/women/signup/choose-design`
  }

  return `${prefix}/men/signup/choose-design`
}

export default function ({ store, route, error, redirect, app }) {
  // Check if specialDesignUrl is lowercase, if not redirect to lowercase version
  if (route.params.specialDesignUrl && route.params.specialDesignUrl !== route.params.specialDesignUrl.toLowerCase()) {
    const queryParamsString = serializeParameters(route.query)
    const lowercaseUrl = route.params.specialDesignUrl.toLowerCase()

    if (store.state.app.locale && store.state.app.country) {
      const i18nParams = `/${store.state.app.locale}-${store.state.app.country}`
      return redirect(`${i18nParams}/${lowercaseUrl}${queryParamsString ? `?${queryParamsString}` : ''}`)
    }

    return redirect(`/${lowercaseUrl}${queryParamsString ? `?${queryParamsString}` : ''}`)
  }

  const specialDesign = store.state.specialDesigns.specialDesigns.find(design => design.url === route.params.specialDesignUrl)

  if (specialDesign && specialDesign.ended) {
    return redirect(forwardToRegularSignup(store, specialDesign))
  }
  if (!specialDesign) {
    return error('Page not found', 404)
  }

  if (specialDesign.startDate) {
    const now = app.$moment.utc()
    const startDate = app.$moment.utc(specialDesign.startDate)

    if (startDate.diff(now, 'minutes', true) <= 1) {
      const signupUrl = getSignupUrl({
        membershipTypeReference: specialDesign.membershipTypeReference,
        designSlug: specialDesign.slug
      })

      return redirect(signupUrl)
    }
  }

  if (!app.$flags.isEnabled({ name: `enable_${specialDesign.slug}_partnerdesign_landingpage` })) {
    return redirect(forwardToRegularSignup(store, specialDesign))
  }
}
